import type { ReactionType } from '@ms/yammer-graphql';

import type { Message } from '../../state/types';

export const getId = (messageId: Message['id'], reaction: ReactionType | null) =>
  `${messageId}-${reaction ?? 'ALL_REACTIONS'}`;
